import * as THREE from 'three';
import type { AssetId } from '../assets/types';

export interface VegetationInstanceDef {
  modelId: AssetId;
  position: THREE.Vector3;
  rotationY: number;
  scale: number;
}

/**
 * Deliberately pure data, with no Three.js scene-graph objects and no
 * rendering logic — see VegetationRenderer for that. Keeping placement
 * data separate from its realization is what lets this be serialized,
 * streamed, or edited independent of rendering, and lets the *rendering*
 * strategy change (see VegetationRenderer) without touching this class.
 */
export class VegetationField {
  private readonly instances: VegetationInstanceDef[] = [];

  add(instance: VegetationInstanceDef): void {
    this.instances.push(instance);
  }

  addMany(list: VegetationInstanceDef[]): void {
    this.instances.push(...list);
  }

  get all(): readonly VegetationInstanceDef[] {
    return this.instances;
  }

  get count(): number {
    return this.instances.length;
  }
}
